import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const {
	MARKETPLACE: { SORTING },
} = ANALYTICS_CATEGORIES;

interface TriggerSortOrderSelectedEventProps {
	sortOrderValue: string;
}

export const triggerSortOrderSelectedEvent = ({ sortOrderValue }: TriggerSortOrderSelectedEventProps): void => {
	const eventPayload = getSnowplowEventPayload({
		category: SORTING,
		customData: { label: sortOrderValue },
		name: 'dlr_mrktplace_sort_order_selected_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
